import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-zinc-900 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <SafeIcon name="Hexagon" className="text-red-600 text-2xl" />
              <span className="font-black text-xl tracking-tight uppercase text-white">PulseForge</span>
            </div>
            <p className="text-zinc-500 text-sm mb-6 max-w-xs">
              Advanced mechanical recovery systems for athletes who demand more from their downtime.
            </p>
            <div className="flex gap-4 text-zinc-400">
              <a href="#" className="hover:text-white transition-colors"><SafeIcon name="Instagram" /></a>
              <a href="#" className="hover:text-white transition-colors"><SafeIcon name="Twitter" /></a>
              <a href="#" className="hover:text-white transition-colors"><SafeIcon name="Youtube" /></a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-white uppercase tracking-wider mb-4 text-sm">Equipment</h4>
            <ul className="space-y-3 text-sm text-zinc-500">
              <li><a href="#" className="hover:text-red-500 transition-colors">ForgeGun Series</a></li>
              <li><a href="#" className="hover:text-red-500 transition-colors">PulseBoots Compression</a></li>
              <li><a href="#" className="hover:text-red-500 transition-colors">Thermal Therapy</a></li>
              <li><a href="#" className="hover:text-red-500 transition-colors">Bundles & Kits</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white uppercase tracking-wider mb-4 text-sm">Support</h4>
            <ul className="space-y-3 text-sm text-zinc-500">
              <li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Warranty Info</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Returns Portal</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contact Lab</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white uppercase tracking-wider mb-4 text-sm">Join The Roster</h4>
            <p className="text-sm text-zinc-500 mb-4">Subscribe for early access to new tech and recovery protocols.</p>
            <div className="flex">
              <input 
                type="email" 
                placeholder="EMAIL ADDRESS" 
                className="bg-zinc-900 border border-zinc-800 text-white px-4 py-2 w-full text-sm focus:outline-none focus:border-red-600"
              />
              <button className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 transition-colors">
                <SafeIcon name="ArrowRight" />
              </button>
            </div>
          </div>

        </div>

        <div className="border-t border-zinc-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-zinc-600">
          <p>&copy; {new Date().getFullYear()} PulseForge Recovery Systems. All rights reserved.</p>
          <div className="flex gap-4">
            <a href="#" className="hover:text-zinc-400">Privacy Policy</a>
            <a href="#" className="hover:text-zinc-400">Terms of Service</a>
          </div>
        </div>
        <p className="text-[10px] text-zinc-800 mt-4 text-center max-w-3xl mx-auto">
          Disclaimer: PulseForge products are engineered for fitness recovery and mobility enhancement. They are not medical devices and are not intended to diagnose, treat, cure, or prevent any disease or medical condition. Consult a physician before starting any new exercise or recovery program.
        </p>
      </div>
    </footer>
  );
};

export default Footer;